import React from "react";
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";

const RadioGroup = ({
  label,
  labelPosition = "left",
  labelWidth = 120,
  align = "center",
  name,
  options = [],
  value,
  onChange,
  orientation = "vertical",
  disabled = false,
  width = "100%",
  style = {},
  inputStyle = {},
  rowGap = null,
  itemGap = null,
  justify = "flex-start",

  // NOUVEAU
  colorMap = null,
  compact = false,
}) => {
  const isHorizontal = orientation === "horizontal";

  const getOptionColor = (optValue) => {
    if (colorMap?.[optValue]?.color) return colorMap[optValue].color;
    return theme.form.label.color;
  };

  return (
    <FormLayout
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <div
        style={{
          display: "flex",
          flexDirection: isHorizontal ? "row" : "column",
          alignItems: isHorizontal ? "center" : "flex-start",
          justifyContent: isHorizontal ? justify : "flex-start",
          gap: isHorizontal
            ? itemGap ?? (compact ? theme.spacing.md : theme.spacing.lg)
            : rowGap ?? (compact ? theme.spacing.sm : theme.spacing.md),
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? "not-allowed" : "default",
          width: "100%",
          fontFamily: theme.form.label.fontFamily,
          flexWrap: isHorizontal ? "nowrap" : "nowrap",
          boxSizing: "border-box",
        }}
      >
        {options.map((opt) => (
          <label
            key={opt.value}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: compact ? 6 : theme.spacing.sm,
              fontFamily: theme.form.label.fontFamily,
              fontSize: compact ? "0.72rem" : theme.form.label.fontSize,
              fontWeight: theme.form.label.fontWeight,
              color: disabled ? theme.colors.text.muted : theme.form.label.color,
              cursor: disabled ? "not-allowed" : "pointer",
              userSelect: "none",
              whiteSpace: "nowrap",
              flex: isHorizontal && justify === "space-between" ? 1 : "0 0 auto",
              minWidth: 0,
            }}
          >
            <input
              type="radio"
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={() => !disabled && onChange(opt.value)}
              disabled={disabled}
              style={{
                accentColor: disabled
                  ? theme.colors.states.disabled
                  : theme.colors.states.enabled,
                cursor: disabled ? "not-allowed" : "pointer",
                fontFamily: theme.form.field.fontFamily,
                fontSize: theme.form.field.fontSize,
                fontWeight: theme.form.field.fontWeight,
                color: theme.form.field.color,
                transition: "all 0.2s ease",
                transform: compact ? "scale(0.95)" : "scale(1)",
                ...inputStyle,
              }}
            />

            <span
              style={{
                color: getOptionColor(opt.value),
              }}
            >
              {opt.label}
            </span>
          </label>
        ))}
      </div>
    </FormLayout>
  );
};

export default RadioGroup;